import React from "react";
import { Link } from "react-router-dom";

export default function SingleCityHotelsCard(props) {
  return (
    <Link to={`/book-now/${props.title}`} className={`col-lg-4 col-sm-6 col-12 mb-lg-${props.mb ? props.mb : 0} mb-sm-4 mb-5 px-2 single-hotel-room-card text-decoration-none`}>
      <div className="card-content-cover">
        <div
          className="image-side mb-3"
          style={{ background: `url(${props.img})` }}
        ></div>
        <div className="details-side">
          <h5 className="hotel-name text-capitalize">{props.title}</h5>
          <p className="mb-2 hotel-night-price">
            {props.totalNoOfHotels.length} Hotels
          </p>
        </div>
      </div>
    </Link>
  );
}
